import styled from "styled-components";

const CommonBtnStyles = `
   background: #424242;
  border: none;
  color: #fff;
  border-radius: 0;
  padding: 1em;
`;

const CommonHeadingStyles = `
 font-family: "Roboto", "Mulish", sans-serif;
  font-weight: 600;
  text-transform: capitalize;
  font-size: 2.5em;
  margin: 0;
`;

export const H1 = styled.h1`
  ${CommonHeadingStyles};
  font-weight: 400;
  color: ${props => props.theme.main};
`;

export const H3 = styled.h3`
  ${CommonHeadingStyles};
  font-size: 1.5em;
  font-weight: 400;
  color: ${props => props.theme.main};
`;

export const H4 = styled.h4`
  ${CommonHeadingStyles};
  font-size: 1.5em;
  font-weight: 400;
  color: ${props => props.theme.main};
`;

export const CostDetailText = styled.div`
  background-color: ${props => props.theme.main};
  padding: 10px;
  text-align: center;

  p {
    font-size: 1.2em;
    margin: 0;
    color: #fff !important;
  }
`;

export const VerticalText = styled.h5`
  ${CommonHeadingStyles};
  font-size: 3em;
  font-weight: 400;
  writing-mode: vertical-rl;
  color: ${props => props.theme.main};

  @media screen and (max-width: 1275px) {
    & {
      display: none;
    }
  }
`;

export const BannerStatus = styled.div`
  color: ${props => props.theme.main};
  font-size: 1.5em;
  text-transform: uppercase;
  padding: 0 1em;
  font-family: "Mulish", "Roboto", sans-serif;
  font-weight: 700;
  margin: 0;

  @media screen and (max-width: 1275px) {
    & {
      background: ${props => props.theme.main};
      color: #fff;
    }
  }
`;

export const OutlineButton = styled.button`
  background: #fff;
  color: ${props => props.theme.main};
  border: 1px solid ${props => props.theme.main};
  font-size: 1.2em;
  height: 45px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  margin-bottom: 1em;
  cursor: pointer;
  padding: 1em;

  &:hover {
    background: ${props => props.theme.main};
    color: #fff;
  }
`;

export const ReqActionBtn = styled.button`
  ${CommonBtnStyles};
  background: ${props => props.theme.main};
  color: #fff !important;
  border-radius: 8px;
  margin-bottom: 1em;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  padding: 0.5em;
  cursor: pointer;

  > img {
    color: #fff;
  }
`;

export const PriceBtn = styled.button`
  margin: 0 auto;
  padding: 0.5em 2em;
  border-radius: 4px;
  font-size: 1.25em;
  height: 45px;
  font-family: "Mulish", "Roboto", sans-serif;
  background-color: ${props => props.theme.main};
  color: #fff;
  border: none;
  cursor: pointer;
`;
